import { render, staticRenderFns } from "./TransferenciasPendentesDistrito.vue?vue&type=template&id=791e0790"
import script from "./TransferenciasPendentesDistrito.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPendentesDistrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports